/**
 * Alpine.js User Carousel Component
 * Horizontal scrolling carousel with arrow navigation
 */
export function userCarousel() {
    return {
        canScrollLeft: false,
        canScrollRight: false,
        _animating: false,

        init() {
            this.$nextTick(() => this.updateArrows());

            this.$el.addEventListener('carousel:refresh', () => {
                this.$nextTick(() => this.updateArrows());
            });

            this._onResize = () => this.updateArrows();
            window.addEventListener('resize', this._onResize);
        },

        destroy() {
            if (this._onResize) {
                window.removeEventListener('resize', this._onResize);
            }
        },

        updateArrows() {
            if (this._animating) return;
            const track = this.$refs.track;
            if (!track || track.scrollWidth === 0) return;
            this.canScrollLeft = track.scrollLeft > 4;
            this.canScrollRight = track.scrollLeft + track.clientWidth < track.scrollWidth - 4;
        },

        onScroll() {
            this.updateArrows();
        },

        scrollLeft() {
            this._scroll(-1);
        },

        scrollRight() {
            this._scroll(1);
        },

        _scroll(direction) {
            const track = this.$refs.track;
            if (!track || this._animating) return;
            this._animating = true;

            track.style.scrollSnapType = 'none';
            const distance = track.clientWidth * 0.75 * direction;
            track.scrollBy({ left: distance, behavior: 'smooth' });

            const check = () => {
                clearTimeout(this._scrollEnd);
                this._scrollEnd = setTimeout(() => {
                    track.style.scrollSnapType = '';
                    this._animating = false;
                    this.updateArrows();
                }, 100);
            };
            track.addEventListener('scroll', check, { passive: true });
            setTimeout(() => {
                track.removeEventListener('scroll', check);
                track.style.scrollSnapType = '';
                this._animating = false;
                this.updateArrows();
            }, 600);
        }
    };
}
